import React from 'react';
import {QuoteStatus} from 'Quoting/models/enum';
import {applyQuoteListFilter} from 'Quoting/ducks/quoteActions';
import {capitalizeSubString} from 'Shared/utilities/stringFormatHelpers';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {makeStyles, Select, MenuItem} from '@material-ui/core';
import {ExpandMore} from '@material-ui/icons';
import {themeColors} from 'Theme';

const useQuoteFilterStyles = makeStyles(() => ({
  label: {
    color: themeColors.gray_800,
    fontSize: '1rem',
    lineHeight: '1.05rem',
    fontWeight: 600,
    marginRight: '1rem',
  },
  filterList: {
    backgroundColor: themeColors.primaryWhite
  }
}));

const quoteStatusOptions = [
  {displayValue: capitalizeSubString('All Status', 0, 1), code: QuoteStatus.AllStatus, orderNo: 0},
  {displayValue: 'Active Quotes', code: 'active', orderNo: 1},
  {
    displayValue: capitalizeSubString(QuoteStatus.ContractAccepted, 0, 1),
    code: QuoteStatus.ContractAccepted,
    orderNo: 2
  },
  {displayValue: capitalizeSubString(QuoteStatus.CompanyDeclined, 0, 1), code: QuoteStatus.CompanyDeclined, orderNo: 3},
  {
    displayValue: capitalizeSubString(QuoteStatus.CustomerDeclined, 0, 1),
    code: QuoteStatus.CustomerDeclined,
    orderNo: 4
  },
  {displayValue: capitalizeSubString(QuoteStatus.DataGather, 0, 1), code: QuoteStatus.DataGather, orderNo: 5},
  {displayValue: capitalizeSubString(QuoteStatus.Initialized, 0, 1), code: QuoteStatus.Initialized, orderNo: 6},
  {displayValue: capitalizeSubString(QuoteStatus.Proposed, 0, 1), code: QuoteStatus.Proposed, orderNo: 7},
  {displayValue: capitalizeSubString(QuoteStatus.Rated, 0, 1), code: QuoteStatus.Rated, orderNo: 8},
  {
    displayValue: capitalizeSubString(QuoteStatus.ReadyForProposal, 0, 1),
    code: QuoteStatus.ReadyForProposal,
    orderNo: 9
  }
];

export const QuoteListFilter = () => {
  const {quoteListFilter} = useSelector((state: ReducerState) => state.quoteActions);
  const dispatch = useDispatch();
  const classes = useQuoteFilterStyles();

  return (
    <div>
      <label className={classes.label} htmlFor="quote-list-filter-select">
        Quote Summary
      </label>
      <Select
        className={classes.filterList}
        value={quoteListFilter ?? ''}
        id="quote-list-filter-select"
        variant="outlined"
        IconComponent={ExpandMore}
        onChange={e => {dispatch(applyQuoteListFilter(e.target.value as QuoteStatus));}}
        style={{
          borderRadius: 0,
          height: '44px',
          width: '12rem'
        }}
      >
        {Array.isArray(quoteStatusOptions) &&
          quoteStatusOptions.map(({code, displayValue}) => (
            <MenuItem value={code} key={`quote-filter-${code}-${displayValue}`}>
              {displayValue}
            </MenuItem>
          ))}
      </Select>
    </div>
  );
};
